export default [
  {
    name: 'test',
    path: '/test',
    component: () => import('@/pages/test/Index.vue'),
  },
]
